import moment from 'moment'

const state = {
  danishHolidays: [
    '01-01-2022',
    '10-04-2022',
    '14-04-2022',
    '15-04-2022',
    '17-04-2022',
    '18-04-2022',
    '13-05-2022',
    '26-05-2022',
    '05-06-2022',
    '06-06-2022',
    '05-06-2022',
    '24-12-2022',
    '25-12-2022',
    '26-12-2022',
    '31-12-2022',
    '01-01-2023',
    '02-04-2023',
    '06-04-2023',
    '07-04-2023',
    '09-04-2023',
    '10-04-2023',
    '05-05-2023',
    '18-05-2023',
    '28-05-2023',
    '29-05-2023',
    '24-12-2023',
    '25-12-2023',
    '26-12-2023',
    '31-12-2023',
    '01-01-2024',
    '24-03-2024',
    '28-03-2024',
    '29-03-2024',
    '31-03-2024',
    '01-04-2024',
    '09-05-2024',
    '19-05-2024',
    '20-05-2024',
    '25-12-2024',
    '26-12-2024',
    '01-01-2025', // Nytårsdag
    '17-04-2025', // Skærtordag
    '18-04-2025', // Langfredag
    '21-04-2025', // 2. Påskedag
    '29-05-2025', // Kristihimmelfart
    '09-06-2025', // 2. Pinsedag
    '25-12-2025', // Juledag
    '26-12-2025', // 2. juledag
    '01-01-2026', // Nytårsdag
    '02-04-2026', // Skærtorsdag
    '03-04-2026', // Langfredag
    '06-04-2026', //  2. påskedag
    '14-05-2026', // Kr. Himmelfartsdag
    '25-05-2026', // 2. pinsedag
    '25-12-2026', // Juledag
    '26-12-2026', // 2. juledag
    '01-01-2027', // Nytårsdag
    '25-03-2027', // Skærtordag
    '26-03-2027', // Langfredag
    '29-04-2027', // 2. Påskedag
    '06-05-2027', // Kristihimmelfart
    '17-05-2027', // 2. Pinsedag
    '25-12-2027', // Juledag
    '26-12-2027', // 2. juledag
    '01-01-2028', // Nytårsdag
    '13-04-2028', // Skærtordag
    '14-04-2028', // Langfredag
    '17-04-2028', // 2. Påskedag
    '25-05-2028', // Kristihimmelfart
    '25-12-2028', // Juledag
    '26-12-2028' // 2. juledag
  ]
}

const getters = {
  holidaysWithinActiveSchoolYear: (state) => (startDate, endDate) => {
    const start = moment(startDate, 'YYYY-MM-DD')
    const end = moment(endDate, 'YYYY-MM-DD')

    return state.danishHolidays.filter(date => {
      const mDate = moment(date, 'DD-MM-YYYY')
      const isAfterStart = mDate.isSameOrAfter(start)
      const isBeforeEnd = mDate.isSameOrBefore(end)
      const isNotWeekend = mDate.isoWeekday() < 6
      return isAfterStart && isBeforeEnd && isNotWeekend
    })
  }
}

export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/danishHolidays.js